import { Navigate, Outlet, OutletProps, useLocation, useSearchParams } from 'react-router-dom'
import { useAuthContext } from '../../context/AuthContext';


export default function PrivateRoute(props:OutletProps) {
  const { user } = useAuthContext()
  const location = useLocation()
  const [searchParams] = useSearchParams()

    
    
   
    if(!user){
      return <Navigate to={`/connect${searchParams.get('token') ? `?token=${searchParams.get('token')}` : ''}`} replace state={{ from: location }} />;
    }
    // if(!user.emailVerified){
    //     return <ValidateEmail />
    // }
    
    return <Outlet {...props}/>
   
}
